export default {
  masterChef: {
    6552: '0x793A1404F7e44f42B1E42283D9ed5DeaAdA81af9',
    65450: '0x9E467884a92e38925a552AFcc357F4A129712a3f',
  },
  masterChefV1: {
    6552: '0x513bf032AB4D99Edf8D3c780be4aD7f99Dea2F28',
    65450: '0x59fA9Dcff5045Cd2c837C94beEDcBC5328A7919B',  
  },
  sousChef: {
    6552: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    65450: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    6552: '0x5790c3534F30437641541a0FA04C992799602998',
    65450: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  multiCall: {
    65450: '0x31bBc06A9CEfDeF740914dc5E4Ef4e048C78BC5F',
    6552: '0xf20eBb7472d41D2C4dC5d40319b8F39706538A8D',
  },
  pancakeProfile: {
    65450: '0x18d7EAC0F1c5bd606e36427f40eA3EeaDA810f12',
    6552: '0x3228631688Ee8A5b619064f5d7E1508E619B42a6',
  },
  pancakeBunnies: {
    //65450: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    65450: '0xa0E8ade4893DEfBc3d15305BEE6E703bC36C6d9c',
    6552: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    //65450: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    65450: '0xfA16Ee18B2185778587E7561676b1947bDC8cd0A',
    6552: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    65450: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    6552: '',
  },
  pointCenterIfo: {
    65450: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    6552: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    65450: '0xFee8A195570a18461146F401d6033f5ab3380849',
    6552: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetitionEaster: {
    65450: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    6552: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  tradingCompetitionFanToken: {
    65450: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    6552: '',
  },
  tradingCompetitionMobox: {
    65450: '0x1C5161CdB145dE35a8961F82b065fd1F75C3BaDf',
    6552: '',
  },
  tradingCompetitionMoD: {
    65450: '0xbDd9a61c67ee16c10f5E37b1D0c907a9EC959f33',
    6552: '',
  },
  easterNft: {
    65450: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    6552: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    65450: '0xC289ee2FD198c275E5e313E65306032db5a3814D',
    6552: '0x9895BDc5d2f73DF8a6B307f030162480fd2eB8B1',
  },
  predictions: {
    65450: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    6552: '',
  },
  chainlinkOracle: {
    65450: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    6552: '',
  },
  bunnySpecialCakeVault: {
    65450: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    6552: '',
  },
  bunnySpecialPrediction: {
    65450: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    6552: '',
  },
  bunnySpecialLottery: {
    65450: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    6552: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  bunnySpecialXmas: {
    65450: '0x59EdDF3c21509dA3b0aCCd7c5ccc596d930f4783',
    6552: '',
  },
  farmAuction: {
    65450: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    6552: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  AnniversaryAchievement: {
    65450: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    6552: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
  },
  galaxyNftClaiming: {
    65450: '0x2D18f2d27D50C9b4013DEBA3D54f60996bD8847E',
    6552: '',
  },
  nftMarket: {
    //65450: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    65450: '0x62109dFC195f61bf8244360e7E502c5c7dd49A2F',
    6552: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  nftSale: {
    65450: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    6552: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    65450: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    6552: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },
}
